import { defineMessages } from 'react-intl';

export default defineMessages({
    FirstNamePlaceholder: {
        id: 'ml.common.namedetails.placeholder.First name',
        defaultMessage: 'First name'
    },
    MiddleNamePlaceholder: {
        id: 'ml.common.namedetails.placeholder.Middle name',
        defaultMessage: 'Middle name'
    },
    LastNamePlaceholder: {
        id: 'ml.common.namedetails.placeholder.Last name',
        defaultMessage: 'Last name'
    },
    noAlphaNumeric_ML: {
        id: 'ml.common.namedetails.placeholder.Only alpha characters',
        defaultMessage: 'Only alpha characters may be entered in this field'
    }
});